import { config } from '@/pageConfig/privacyPolicy/us/en';
import { PrivacyPolicyPageTemplate } from '@/pageTemplate/PrivacyPolicyTemplate';
import { useAnalyticsContext } from '@lemonade-hq/nuiza';
import { useEffect } from 'react';

export default function RentersPage() {
  const { trackEvent } = useAnalyticsContext();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => trackEvent('privacy-policy_page.viewed', { variant: 'default' }), []);

  return <PrivacyPolicyPageTemplate config={config} />;
}
